/* ═══════════════════════════════════════════════
   DAR LUXE — Theme JavaScript (Complete Rewrite)
   All fixes: Variants, Zoom, Video, Quick Add
   ═══════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ─── Sticky Header ─── */
  var header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 60) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    }, { passive: true });
  }

  /* ─── Cart Drawer ─── */
  var cartDrawer = document.querySelector('.cart-drawer');
  var cartClose = document.querySelector('.cart-drawer__close');
  var overlay = document.getElementById('overlay');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  /* ─── Mobile Menu ─── */
  var menuToggle = document.querySelector('.header__menu-toggle');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
      if (overlay) overlay.classList.toggle('active');
    });
  }

  /* ─── Scroll Reveal ─── */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length > 0) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ─── Product Gallery: Thumbnails + Video ─── */
  var thumbs = document.querySelectorAll('.product-gallery__thumb');
  var mainContainer = document.getElementById('mainImageContainer');
  var mainImage = document.getElementById('mainProductImage');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');

      var mediaType = thumb.getAttribute('data-media-type');

      if (mediaType === 'video') {
        // Show video
        var videoId = thumb.getAttribute('data-media-id');
        var videoContainer = document.querySelector('#productVideos [data-video-id="' + videoId + '"]');
        if (videoContainer && mainContainer) {
          mainContainer.innerHTML = videoContainer.innerHTML;
          // Auto-play the video
          var vid = mainContainer.querySelector('video');
          if (vid) vid.play();
        }
      } else {
        // Show image
        var newSrc = thumb.getAttribute('data-src');
        var fullSrc = thumb.getAttribute('data-full-src') || newSrc;
        if (mainContainer) {
          mainContainer.innerHTML = '<img id="mainProductImage" src="' + newSrc + '" data-full-src="' + fullSrc + '" alt="Product image" style="width:100%;height:auto;max-height:600px;object-fit:contain;cursor:zoom-in;transition:opacity 0.25s ease;">';
          mainImage = document.getElementById('mainProductImage');
          attachZoomToMainImage();
        }
      }
    });
  });

  /* ─── Product Image Zoom ─── */
  var zoomOverlay = document.getElementById('productZoom');
  var zoomImage = document.getElementById('zoomImage');
  var zoomClose = document.getElementById('zoomClose');

  function attachZoomToMainImage() {
    var img = document.getElementById('mainProductImage');
    if (!img || !zoomOverlay) return;
    img.addEventListener('click', function () {
      var fullSrc = img.getAttribute('data-full-src') || img.src;
      zoomImage.src = fullSrc;
      zoomOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }
  attachZoomToMainImage();

  if (zoomOverlay) {
    zoomOverlay.addEventListener('click', function (e) {
      if (e.target === zoomOverlay || e.target === zoomImage) {
        zoomOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }
  if (zoomClose) {
    zoomClose.addEventListener('click', function () {
      zoomOverlay.classList.remove('active');
      document.body.style.overflow = '';
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && zoomOverlay && zoomOverlay.classList.contains('active')) {
      zoomOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  });

  /* ─── Quantity Selector ─── */
  document.querySelectorAll('.quantity-selector').forEach(function (selector) {
    var minus = selector.querySelector('[data-qty-minus]');
    var plus = selector.querySelector('[data-qty-plus]');
    var input = selector.querySelector('.quantity-input');
    if (minus && plus && input) {
      minus.addEventListener('click', function () {
        var val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
      plus.addEventListener('click', function () {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  /* ─── Countdown Timer ─── */
  var countdownEl = document.querySelector('[data-countdown]');
  if (countdownEl) {
    var endDate = new Date(countdownEl.dataset.countdown).getTime();
    function updateCountdown() {
      var now = new Date().getTime();
      var distance = endDate - now;
      if (distance < 0) { countdownEl.innerHTML = '<span class="label">Sale Ended</span>'; return; }
      var days = Math.floor(distance / (1000*60*60*24));
      var hours = Math.floor((distance % (1000*60*60*24)) / (1000*60*60));
      var mins = Math.floor((distance % (1000*60*60)) / (1000*60));
      var secs = Math.floor((distance % (1000*60)) / 1000);
      var dE=countdownEl.querySelector('[data-days]'),hE=countdownEl.querySelector('[data-hours]'),mE=countdownEl.querySelector('[data-mins]'),sE=countdownEl.querySelector('[data-secs]');
      if(dE)dE.textContent=String(days).padStart(2,'0');if(hE)hE.textContent=String(hours).padStart(2,'0');if(mE)mE.textContent=String(mins).padStart(2,'0');if(sE)sE.textContent=String(secs).padStart(2,'0');
    }
    updateCountdown(); setInterval(updateCountdown, 1000);
  }

  /* ─── Marquee ─── */
  var marqueeInner = document.querySelector('.marquee__inner');
  if (marqueeInner) { marqueeInner.parentNode.appendChild(marqueeInner.cloneNode(true)); }

  /* ─── Announcement Bar close ─── */
  var announcementClose = document.querySelector('[data-announcement-close]');
  if (announcementClose) {
    announcementClose.addEventListener('click', function () {
      announcementClose.closest('.announcement-bar').style.display = 'none';
    });
  }

  /* ─── Quick Add AJAX (Collection page) ─── */
  function updateCartDrawer() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        // 1. Update cart count badge in header
        document.querySelectorAll('.header__cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
        });

        // 2. Update cart drawer header
        var drawerHeader = document.querySelector('.cart-drawer__header h3');
        if (drawerHeader) drawerHeader.textContent = 'Your Cart (' + cart.item_count + ')';

        // 3. Rebuild cart drawer items
        var drawerItems = document.querySelector('.cart-drawer__items');
        if (!drawerItems) return;

        if (cart.item_count === 0) {
          drawerItems.innerHTML = '<div style="text-align:center;padding:48px 0;color:var(--color-text-muted);"><p style="font-family:var(--font-heading);font-size:1.2rem;margin-bottom:8px;">Your cart is empty</p><p style="font-size:0.9rem;">Discover our collections and find something you love.</p><a href="/collections/all" class="btn btn--outline mt-lg">Shop Now</a></div>';
          var drawerFooter = document.querySelector('.cart-drawer__footer');
          if (drawerFooter) drawerFooter.style.display = 'none';
          return;
        }

        var html = '';
        cart.items.forEach(function(item, index) {
          var imgSrc = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_200x$1$2') : '';
          var priceFormatted = 'Dhs. ' + (item.final_line_price / 100).toFixed(2);
          var variantTitle = item.variant_title;
          var variantDisplay = (variantTitle && variantTitle !== 'Default Title') ? variantTitle + ' \u00b7 ' : '';
          html += '<div class="cart-item" style="position:relative;">';
          html += '<div class="cart-item__image">';
          if (imgSrc) html += '<img src="' + imgSrc + '" alt="' + item.product_title + '" loading="lazy">';
          html += '</div>';
          html += '<div style="flex:1;">';
          html += '<div class="cart-item__title">' + item.product_title + '</div>';
          html += '<div class="cart-item__variant">' + variantDisplay + 'Qty: ' + item.quantity + '</div>';
          html += '<div class="cart-item__price">' + priceFormatted + '</div>';
          html += '</div>';
          html += '<button class="cart-item__remove" data-line="' + (index + 1) + '" aria-label="Remove" style="position:absolute;top:8px;right:0;width:28px;height:28px;display:flex;align-items:center;justify-content:center;color:var(--color-text-muted,#999);font-size:18px;text-decoration:none;border:none;background:transparent;border-radius:50%;cursor:pointer;transition:all 0.2s;">';
          html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 6L6 18M6 6l12 12"/></svg>';
          html += '</button>';
          html += '</div>';
        });
        drawerItems.innerHTML = html;

        // 4. Attach remove handlers to new buttons
        drawerItems.querySelectorAll('.cart-item__remove').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var line = btn.getAttribute('data-line');
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: parseInt(line), quantity: 0 })
            })
            .then(function() { updateCartDrawer(); });
          });
        });

        // 5. Update footer (subtotal + show footer)
        var drawerFooter = document.querySelector('.cart-drawer__footer');
        if (drawerFooter) {
          drawerFooter.style.display = '';
          var subtotalEl = drawerFooter.querySelector('.cart-drawer__total-price');
          if (subtotalEl) subtotalEl.textContent = 'Dhs. ' + (cart.total_price / 100).toFixed(2);
        }
      });
  }

  /* ─── Quick Add AJAX (Collection page) → Add + Redirect to Checkout ─── */
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-quick-add');
      var originalText = btn.textContent;
      btn.textContent = 'Processing...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = '✓ Redirecting...';
        btn.style.background = 'var(--color-success, #10B981)';
        window.location.href = '/checkout';
      })
      .catch(function() {
        btn.textContent = 'Error';
        setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 2000);
      });
    });
  });

  /* ─── Product Page: Buy Now → Redirect to Checkout ─── */
  var buyNowBtn = document.querySelector('[data-buy-now]');
  var productForm = document.querySelector('form[action*="/cart/add"]');

  if (buyNowBtn && productForm) {
    buyNowBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var originalText = buyNowBtn.textContent;
      buyNowBtn.textContent = 'Processing...';
      buyNowBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(productForm)
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        window.location.href = '/checkout';
      })
      .catch(function() {
        buyNowBtn.textContent = 'Error — try again';
        setTimeout(function() { buyNowBtn.textContent = originalText; buyNowBtn.disabled = false; }, 2000);
      });
    });
  }

  /* ─── Product Page: Add to Cart → Open Cart Drawer ─── */
  var addToCartBtn = document.querySelector('[data-add-to-cart]');
  if (addToCartBtn && productForm) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var originalText = addToCartBtn.textContent;
      addToCartBtn.textContent = 'Adding...';
      addToCartBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(productForm)
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        addToCartBtn.textContent = '✓ Added!';
        addToCartBtn.style.borderColor = 'var(--color-success, #10B981)';
        addToCartBtn.style.color = 'var(--color-success, #10B981)';

        // Rebuild entire cart drawer (count + items + footer)
        updateCartDrawer();

        // Open cart drawer
        var cd = document.querySelector('.cart-drawer');
        var ov = document.getElementById('overlay');
        if (cd) cd.classList.add('open');
        if (ov) ov.classList.add('active');
        document.body.style.overflow = 'hidden';

        setTimeout(function() {
          addToCartBtn.textContent = originalText;
          addToCartBtn.disabled = false;
          addToCartBtn.style.borderColor = '';
          addToCartBtn.style.color = '';
        }, 2000);
      })
      .catch(function() {
        addToCartBtn.textContent = 'Error';
        setTimeout(function() { addToCartBtn.textContent = originalText; addToCartBtn.disabled = false; }, 2000);
      });
    });
  }

  /* ─── Prevent default form submit on product page ─── */
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
    });
  }

}); /* End DOMContentLoaded */


/* ═══════════════════════════════════════════════
   VARIANT LOGIC — Complete
   Fixes: image switching + correct variant to cart + price + URL
   ═══════════════════════════════════════════════ */
document.addEventListener('DOMContentLoaded', function () {
  var variantSelectors = document.querySelectorAll('.variant-selector');
  var hiddenInput = document.querySelector('input[type="hidden"][name="id"]');
  var mainContainer = document.getElementById('mainImageContainer');

  if (!variantSelectors.length || !window.productVariants) return;

  var variants = window.productVariants;

  function getSelectedOptions() {
    var selected = [];
    variantSelectors.forEach(function(sel) {
      var btn = sel.querySelector('.variant-option.selected');
      if (btn) selected.push(btn.getAttribute('data-value'));
    });
    return selected;
  }

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], match = true;
      for (var j = 0; j < opts.length; j++) {
        if (!opts[j] || !v.options[j]) { match = false; break; }
        if (opts[j].trim().toLowerCase() !== v.options[j].trim().toLowerCase()) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function formatMoney(cents) { return 'Dhs. ' + (cents / 100).toFixed(2); }

  function updateVariant() {
    var opts = getSelectedOptions();
    var variant = findVariant(opts);
    if (!variant) return;

    // 1. Update hidden input
    if (hiddenInput) hiddenInput.value = variant.id;

    // 2. Update image
    if (variant.featured_image && mainContainer) {
      var newSrc = variant.featured_image.src;
      var fullSrc = newSrc.split('?')[0] + '?width=2000';
      newSrc = newSrc.split('?')[0] + '?width=1000';
      mainContainer.innerHTML = '<img id="mainProductImage" src="' + newSrc + '" data-full-src="' + fullSrc + '" alt="' + (variant.title || '') + '" style="width:100%;height:auto;max-height:600px;object-fit:contain;cursor:zoom-in;transition:opacity 0.25s ease;">';

      // Re-attach zoom
      var newImg = document.getElementById('mainProductImage');
      var zoomOv = document.getElementById('productZoom');
      var zoomImg = document.getElementById('zoomImage');
      if (newImg && zoomOv && zoomImg) {
        newImg.addEventListener('click', function() {
          zoomImg.src = newImg.getAttribute('data-full-src') || newImg.src;
          zoomOv.classList.add('active');
          document.body.style.overflow = 'hidden';
        });
      }

      // Highlight matching thumbnail
      document.querySelectorAll('.product-gallery__thumb').forEach(function(t) {
        t.classList.remove('active');
        var tSrc = (t.getAttribute('data-src') || '').split('?')[0].split('/').pop();
        var vSrc = newSrc.split('?')[0].split('/').pop();
        if (tSrc && vSrc && tSrc === vSrc) t.classList.add('active');
      });
    }

    // 3. Update price
    var priceEl = document.querySelector('.product-info__price-current');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    var compareEl = document.querySelector('.product-info__price-compare');
    var badgeEl = document.querySelector('.badge--sale');
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (compareEl) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.style.display = ''; }
      if (badgeEl) { badgeEl.textContent = 'Save ' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%'; badgeEl.style.display = ''; }
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (badgeEl) badgeEl.style.display = 'none';
    }

    // 4. Update button
    var submitBtn = document.querySelector('form[action*="/cart/add"] [type="submit"]:not([name="checkout"])');
    if (submitBtn) {
      if (variant.available) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Add to Cart — ' + formatMoney(variant.price);
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sold Out';
      }
    }

    // 5. Update URL
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch(e) {}
  }

  // Click handlers for variant buttons
  document.querySelectorAll('.variant-option').forEach(function(option) {
    option.addEventListener('click', function() {
      var parent = option.closest('.variant-selector__options');
      parent.querySelectorAll('.variant-option').forEach(function(o) { o.classList.remove('selected'); });
      option.classList.add('selected');
      updateVariant();
    });
  });

  // Handle URL variant on page load
  var urlParams = new URLSearchParams(window.location.search);
  var urlVariantId = urlParams.get('variant');
  if (urlVariantId) {
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(urlVariantId)) {
        var v = variants[i];
        variantSelectors.forEach(function(sel, idx) {
          if (!v.options[idx]) return;
          sel.querySelectorAll('.variant-option').forEach(function(btn) {
            btn.classList.remove('selected');
            if (btn.getAttribute('data-value') === v.options[idx]) btn.classList.add('selected');
          });
        });
        break;
      }
    }
  }

  updateVariant();
});
